<template>
  <div class="product-row mb-4">
    <div class="product-image">
      <img :src="item.image" alt width="52" />
    </div>

    <div class="product-info">
      <div class="text-bold mb-1">{{ item.name }}</div>
      <!-- update descriptions -->
      <div class="mb-3">{{ item.description }}</div>
      <!-- <a href>Learn more about {{ item.name }}</a> -->
    </div>

    <div class="pricing">
      <div class="subtotal text-bold">${{ calculateSubtotal(item.id) }}</div>
      <div class="price">${{ item.price }} each</div>
    </div>
    <div class="product-quantity">
      <NumberInput
        controls
        :readonly="readonly"
        :value="getCartQuantity(item.id)"
        @change="(quantity) => updateQuantity(item, quantity)"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import formatCurrency from "../Libraries/formatCurrency";
import NumberInput from "./NumberInput";
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    quantity: {
      type: Number
    }
  },

  components: {
    NumberInput
  },

  computed: {
    ...mapState(["cart"])
  },

  methods: {
    ...mapActions(["setInterestedEquipmentQty", "setCartItem"]),

    /**
     * Get equipment item quantity from the cart
     * defaults to 0 if no in cart
     */
    getCartQuantity(id) {
      if (this.quantity) {
        return this.quantity;
      }

      let cartItem = this.cart.find(cartItem => cartItem.id === id);

      if (!cartItem) return 0;

      return cartItem.quantity;
    },

    /**
     * Update the equipment quantity
     */
    updateQuantity(equipmentItem, quantity) {
      this.setCartItem({
        id: equipmentItem.id,
        price: equipmentItem.price,
        quantity: quantity
      });
      // this.$emit("change", equipment);
    },

    calculateSubtotal(id) {
      if (this.quantity) {
        let quantity = this.quantity;
        let price = this.item.price;
        let total = quantity * price;
        return total
      }

      let cartItem = this.cart.find(cartItem => cartItem.id === id);

      if (!cartItem) return 0;

      let quantity = cartItem.quantity;
      let price = cartItem.price;
      let total = quantity * price;

      let formatted = formatCurrency(total).replace(".00", "");

      return formatted;
    }
  }
};
</script>

<style lang="scss" scoped>
.product-row {
  display: flex;
  padding-bottom: 4rem;
  border-bottom: 1px solid #b5b5b5;
  &:only-of-type {
    border-bottom: none;
    padding-bottom: 0;
  }
  &:last-of-type {
    border-bottom: none;
    padding-bottom: 0;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}

.product-image {
  margin-right: 1.5rem;
  width: 80px;
  height: 80px;
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
  @media (max-width: 480px) {
    margin-right: 0;
  }
}

.product-quantity {
  max-width: 150px;
  display: flex;
  align-items: center;
}

.product-info {
  max-width: 300px;
  @media (max-width: 768px) {
    max-width: 240px;
  }
  @media (max-width: 480px) {
    max-width: 100%;
  }
}

.pricing {
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  color: #989898;
  @media (max-width: 480px) {
    margin: 1rem 0;
  }
  .subtotal {
    margin-right: 1rem;
    font-size: 1.25em;
  }
}
</style>

<style lang="css">
.number-input__input {
  text-align: center;
}
</style>
